export default __webpack_public_path__ + "static/media/G00RP.29bcc0aa.jpg";